export default "__VITE_ASSET__D$hcN97Z__"